import md5 from 'md5';
import React, { useState } from 'react';
import Gravatar from 'react-gravatar';
import { useSelector } from 'react-redux';
import styles from '../styles/contactImage.scss';
import { ContactIcon, PhonebookIcon, VirtualIcon } from './icons';
const ContactImage = ({ email, id, type, status }) => {
    const linkedUsersMap = useSelector((state) => state.client.linkedUsersMap);
    const [gravatarExists, setGravatarExists] = useState(true);
    let icon;
    switch (type) {
        case 'phonebookentry': {
            icon = React.createElement(PhonebookIcon, { className: styles.icon });
            break;
        }
        case 'phone': {
            icon = React.createElement(ContactIcon, { className: styles.icon });
            break;
        }
        case 'virtual': {
            icon = React.createElement(VirtualIcon, { className: styles.icon });
            break;
        }
        default: {
            icon = React.createElement(PhonebookIcon, { className: styles.icon });
            break;
        }
    }
    const showStatus = type === 'phone' && status !== false;
    let statusClass;
    let containerClass = styles.img_container;
    switch (status) {
        case 'ACTIVE': {
            statusClass = styles.status_active;
            break;
        }
        case 'INACTIVE': {
            statusClass = styles.status_inactive;
            break;
        }
        case 'RINGING': {
            statusClass = styles.status_ringing;
            containerClass = styles.img_container_ringing;
            break;
        }
        case 'UNKNOWN':
        default: {
            statusClass = styles.status_unknown;
            break;
        }
    }
    let contactEmail = id ? undefined : email;
    if (id && linkedUsersMap) {
        contactEmail = linkedUsersMap[id];
    }
    return (React.createElement("div", { className: containerClass },
        contactEmail && gravatarExists ? (React.createElement(Gravatar, { md5: md5(contactEmail), className: styles.img, default: '404', onError: () => {
                setGravatarExists(false);
            }, protocol: 'https://' })) : (icon),
        showStatus ? React.createElement("div", { className: statusClass }) : ''));
};
export default React.memo(ContactImage);
